import { render, staticRenderFns } from "./studentLoginPage.vue?vue&type=template&id=18a8ff3a&scoped=true"
import script from "./studentLoginPage.vue?vue&type=script&lang=js"
export * from "./studentLoginPage.vue?vue&type=script&lang=js"
import style0 from "./studentLoginPage.vue?vue&type=style&index=0&id=18a8ff3a&prod&lang=css"
import style1 from "./studentLoginPage.vue?vue&type=style&index=1&id=18a8ff3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a8ff3a",
  null
  
)

export default component.exports